/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// Mantine
import {
	TextInput as NativeTextInput,
	TextInputProps,
} from '@mantine/core';

// Styles
import classes from './TextInput.module.css';

/* -------------------------------------------------------------------------- */
/*                                    Type                                    */
/* -------------------------------------------------------------------------- */

export type TTextInputProps = TextInputProps;

/* -------------------------------------------------------------------------- */
/*                                  Component                                 */
/* -------------------------------------------------------------------------- */
export const TextInput = (props: TTextInputProps) => {
	/* ******************************** RENDERING ******************************* */
	return (
		<NativeTextInput classNames={classes} {...props} />
	);
};
